<template>
  <div>
    <!-- <b-overlay
      :show="show_overlay"
      rounded="sm"
    > -->
    <validation-observer ref="userDetailsValidation">
      <b-row class="d-flex align-items-start">
        <!-- <b-overlay :show="show" rounded="sm"> -->
        <b-col cols="3">
          <b-card>
            <b-col
              cols="21"
              class="d-flex justify-content-between flex-column"
            >
              <div
                class="d-flex flex-column align-items-center justify-content-start"
              >
                <b-avatar
                  :src="GET_ONE_USER.photo"
                  size="250px"
                  rounded
                />
                <div class="d-flex flex-column ml-1">
                  <div class="d-flex mt-2 flex-wrap">
                    <b-form-file
                      v-model="user_photo_new"
                      :placeholder="$t('userManagement.choose_file_or_drop')"
                      :drop-placeholder="$t('userManagement.drop_file_here')"
                      :browse-text="$t('userManagement.browse')"
                      @input="photoChange"
                    />
                    <b-button
                      variant="danger"
                      class="ml-auto mt-1"
                      @click="deletePhoto"
                    >
                      <feather-icon icon="TrashIcon" />
                      {{ $t('userManagement.delete') }}
                    </b-button>
                  </div>
                </div>
              </div>
            </b-col>
          </b-card>
        </b-col>

        <b-col cols="6">
          <b-card>
            <b-row>
              <b-col cols="12">
                <!-- default label -->
                <b-icon
                  icon="battery-full"
                  style="color: #7952b3;"
                />
                <b-form-group
                  :label="$t('userManagement.username')"
                  label-for="username"
                >
                  <b-form-input
                    id="username"
                    readonly
                    :value="GET_ONE_USER.username"
                    placeholder="Username"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <!-- default label -->
                <b-form-group
                  :label="$t('userManagement.password')"
                  label-for="password"
                >
                  <b-input-group>
                    <b-form-input
                      readonly
                      placeholder="············"
                    />
                    <b-input-group-append>
                      <b-button
                        v-b-modal.modal-password
                        variant="outline-primary"
                      >
                        {{ $t('userManagement.change') }}
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group
                  :label="$t('userManagement.roles')"
                  label-for="Roles"
                >
                  <v-select
                    v-model="GET_ONE_USER.role"
                    multiple
                    :get-option-label="getCustomLabel"
                    :reduce="opt => opt.id"
                    :options="GET_ROLES"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  :label="$t('userManagement.sale_offices')"
                  label-for="saleOffice"
                >
                  <v-select
                    v-model="GET_ONE_USER.sale_office"
                    class="style-chooser"
                    label="title"
                    multiple
                    :options="GET_SALE_OFFICES"
                    :reduce="office => office.id"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="px-1">
              <!-- <b-col md="4">
                  <b-form-group
                    :label="$t('userManagement.status')"
                    label-for="status"
                  >
                    <b-form-checkbox
                      v-model="GET_ONE_USER.is_active"
                      class="mt-50"
                      name="check-button"
                      switch
                      inline
                    >
                      {{
                        GET_ONE_USER.is_active
                          ? $t('userManagement.active')
                          : $t('userManagement.not_active')
                      }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-col> -->
              <b-col md="4">
                <b-form-group
                  :label="$t('userManagement.theme')"
                  label-for="Theme"
                >
                  <v-select
                    v-model="GET_ONE_USER.theme"
                    label="title"
                    :options="theme_options"
                    :reduce="t => t.value"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  :label="$t('userManagement.language')"
                  label-for="Language"
                >
                  <v-select
                    v-model="GET_ONE_USER.language"
                    label="name"
                    :options="getLangOptions"
                    :reduce="lang => lang.locale"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <b-col
          class="mb-2"
          cols="3"
        >
          <b-card>
            <b-col cols="12">
              <!-- default label -->
              <b-form-group
                :label="$t('userManagement.first_name')"
                label-for="first-name"
              >
                <b-form-input
                  id="first-name"
                  v-model="GET_ONE_USER.first_name"
                  :value="GET_ONE_USER.first_name"
                  :placeholder="$t('userManagement.first_name')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <!-- default label -->
              <b-form-group
                :label="$t('userManagement.last_name')"
                label-for="last-name"
              >
                <b-form-input
                  id="last-name"
                  v-model="GET_ONE_USER.last_name"
                  :value="GET_ONE_USER.last_name"
                  :placeholder="$t('userManagement.last_name')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <!-- default label -->
              <b-form-group
                :label="$t('userManagement.email')"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="GET_ONE_USER.email"
                  :value="GET_ONE_USER.email"
                  placeholder="email"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                name="Phone Number"
                rules="required"
              >
                <b-form-group
                  :label="$t('userManagement.phone_number')"
                  label-for="phone-number"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="formattedPhoneValue"
                      type="text"
                      placeholder="+998-xx-xxx-xx-xx"
                      @keyup="formatPhone"
                    />
                  </b-input-group>
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-card>

          <b-row class="d-flex justify-content-end">
            <b-button
              class="mr-2"
              variant="secondary"
              @click="$router.push({ name: 'users-list' })"
            >
              {{ $t('userManagement.cancel') }}
            </b-button>
            <b-button
              class="mr-2"
              variant="primary"
              @click="saveChanges()"
            >
              {{ $t('userManagement.save_changes') }}
            </b-button>
          </b-row>
        </b-col>
        <password-change-modal />
      </b-row>
    </validation-observer>
    <!-- </b-overlay> -->
  </div>
</template>

<script>

import {
  BCard,
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormFile,
  BInputGroupAppend,
  BInputGroup,
  // BFormCheckbox,
  // BOverlay,
  BIcon,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import VSelect from 'vue-select'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import useJwt from '@/auth/jwt/useJwt'
import locales from '@/utils/locales'
// eslint-disable-next-line import/no-extraneous-dependencies
import passwordChangeModal from './components/passwordChangeModal.vue'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BFormGroup,
    BFormInput,
    BInputGroup,
    VSelect,
    // BFormCheckbox,
    BInputGroupAppend,
    BFormFile,
    // BOverlay,
    ValidationProvider,
    ValidationObserver,
    FeatherIcon,
    BIcon,
    passwordChangeModal,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      user_id: this.$route.params.id,
      show_overlay: false,
      user_photo_new: null,
      theme_options: [
        {
          title: 'Dark',
          value: 0,
        },
        {
          title: 'Light',
          value: 1,
        },
      ],
      modal_password: false,
      is_photo_changed: false,
      old_user_details: '',
      phoneValue: 0,
      formattedPhoneValue: '',
      preventNextIteration: false,
      user_data: {},
    }
  },
  computed: {
    ...mapGetters('users', [
      'GET_ONE_USER',
      'GET_ROLES',
    ]),
    ...mapGetters('knowledgeBase', ['GET_SALE_OFFICES']),
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    role_options() {
      if (useJwt.getUserData().is_superuser) {
        return this.GET_ROLES
      }
      return []
    },
    checkIfAdmin() {
      return useJwt.getUserData().is_superuser
    },
    getLangOptions() {
      return locales
    },
  },
  mounted() {
    this.refresh()
    this.FETCH_ROLES()
    this.FETCH_SALE_OFFICES()
  },
  methods: {
    ...mapActions('users', [
      'FETCH_ONE_USER',
      'EDIT_USER',
      'GET_USER_DATA',
      'FETCH_ROLES',
    ]),
    ...mapActions('knowledgeBase', ['FETCH_SALE_OFFICES']),
    refresh() {
      this.FETCH_ONE_USER(this.$route.params.id || useJwt.getUserData().id).then(() => {
        this.user_data = this.GET_ONE_USER
        this.formattedPhoneValue = this.GET_ONE_USER.phone_number.replace(/(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})/g, '+$1-$2-$3-$4-$5')
      })
    },
    saveChanges() {
      this.GET_ONE_USER.phone_number = this.formattedPhoneValue.replace(/[^0-9]+/gi, '')
      const { photo, ...rest } = this.GET_ONE_USER
      this.$refs.userDetailsValidation.validate().then(success => {
        if (success) {
          this.EDIT_USER({ ...rest }).then(() => {
            this.$_successToast(this.$t('generals.changed'))
            this.refresh()
            this.$router.push({ name: 'users-list' })
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
          if (this.is_photo_changed && this.GET_ONE_USER.photo) {
            const fd = new FormData()
            fd.append('id', this.GET_ONE_USER.id)
            fd.append('photo', this.GET_ONE_USER.photo)
            this.EDIT_USER(fd).then(() => {
              this.refresh()
            })
          }
        }
      })
    },
    getCustomLabel(opt) {
      const lang = this.$i18n.locale || 'uz'
      return opt && opt.name && opt.name[lang]
    },
    async photoChange(file) {
      this.GET_ONE_USER.photo = file
      this.is_photo_changed = true
    },
    async deletePhoto() {
      this.GET_ONE_USER.photo = null
      this.user_photo_new = null
      this.is_photo_changed = true
      const obj = {
        photo: null,
        id: this.GET_ONE_USER.id,
      }
      await this.EDIT_USER(obj)
    },
    formatPhone(event) {
      if (['Arrow', 'Backspace', 'Shift'].includes(event.key)) {
        this.preventNextIteration = true
        return
      }
      if (this.preventNextIteration) {
        this.preventNextIteration = false
        return
      }
      const [first] = this.formattedPhoneValue.replace(/-/g, '').match(/(\d{1,12})/g)
      this.phoneValue = first

      // Format display value based on calculated currencyValue
      this.formattedPhoneValue = this.phoneValue.replace(/(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})/g, '+$1-$2-$3-$4-$5')
    },
  },
}
</script>

<style lang="scss">

</style>
